import { Sparkles } from "lucide-react";
import { Button } from "../primitives/Button";

/**
 * SILL-521 M2 cluster 4 — the free-tier copilot allowance surfaces. `pro`
 * tier never renders either of these (the 50/day cap is generous enough that
 * a counter would just be noise) — see `ChatDockPanel`'s `isFreeTier` gate.
 */

/** Compact remaining-turns line, shown above the composer while the free
 *  tier still has messages left today. */
export function AllowanceLine({
  remaining,
  limit,
}: {
  remaining: number;
  limit: number;
}) {
  return (
    <p
      data-testid="copilot-allowance-line"
      className="px-3 pt-1.5 text-center text-[11px] text-fg-muted"
    >
      {remaining} of {limit} free messages today
    </p>
  );
}

// Sill Pro's copilot daily cap (mirrors CRMBillingSummaryVM.aiDailyCap /
// FIXTURE_CRM_BILLING_PRO — the plan's cap, not the free-tier allowance
// response's `limit`, which is the FREE cap being displaced here). Not wired
// live from the billing summary: the exhaustion state is reached from the
// allowance endpoint alone, and this number is a stable plan constant.
const PRO_TIER_DAILY_CAP = 50;

/**
 * Post-exhaustion state (SILL-521 M2 cluster 4): REPLACES the composer once
 * the free tier's daily allowance hits zero — an event-moment affordance,
 * not a new modal/banner. `TrustLine` still renders below this unchanged.
 */
export function ExhaustedComposer({ onUpgrade }: { onUpgrade?: () => void }) {
  return (
    <div
      data-testid="copilot-allowance-exhausted"
      className="flex items-center gap-2.5 border-t border-border-soft px-3 py-2.5"
    >
      <Sparkles size={15} className="shrink-0 text-pro" aria-hidden />
      <p className="flex-1 text-xs text-fg-muted">
        You&apos;ve used today&apos;s free messages — Sill Pro includes{" "}
        {PRO_TIER_DAILY_CAP}/day.
      </p>
      <Button size="sm" onClick={onUpgrade}>
        Upgrade
      </Button>
    </div>
  );
}
